import { useState } from "react";
import TextInput from "@shared/v2/TextInput";
import Button from "@shared/v2/Button";
import Tooltip from "@shared/v2/Tooltip";
import Checkbox from "@shared/v2/Checkbox";
import { CircleInfoSolidV6 } from "@shared/v2/Icomoon";
import CollapsibleWebsiteCard from "../shared/CollapsibleWebsiteCard";
import ImageDropTarget from "../shared/ImageDropTarget";
import FeaturedImageHelpModal from "../shared/FeaturedImageHelpModal";

const ThumbnailPanel = () => {
  const initialPage = { title: "", area: "", featuredImageUrl: "" };
  const [page, setPage] = useState(initialPage);
  const [featuredImageModalIsOpen, setFeaturedImageModalIsOpen] = useState(false);

  return (
    <>
      <CollapsibleWebsiteCard title="Thumbnail">
        <div className="tw-flex tw-flex-col tw-gap-[24px]">
          <div className="tw-flex tw-flex-row tw-gap-[2px]">
            <Checkbox
              label="Use Featured Image for thumbnail"
              onChange={() => {
                //   updateConfig("propertyTypes", type.id);
              }}
              checked={false}
            />
            <Tooltip
              innerClassName="!tw-text-left tw-max-w-[160px]"
              trigger={<CircleInfoSolidV6 />}
              content="This image is displayed in the Explore More Areas block when site visitors are viewing  Area Pages. Thumbnails are vertically oriented and certain details of the image may be cropped out."
            />
          </div>
          {page?.featuredImageUrl && (
            <div className="tw-flex tw-flex-col tw-gap-[8px]">
              <img
                className="tw-w-full tw-h-[150px] tw-rounded-[8px] tw-object-cover"
                src={
                  typeof page.featuredImageUrl === "string"
                    ? page.featuredImageUrl
                    : URL.createObjectURL(page.featuredImageUrl)
                }
                alt="Featured"
              />
              <div className="tw-flex tw-justify-between tw-items-center tw-gap-[8px]">
                <Button
                  className="tw-flex-1"
                  schema="warning"
                  size="small"
                  onClick={() => setPage((p) => ({ ...p, featuredImageUrl: null }))}
                >
                  Delete
                </Button>
                <Button
                  className="tw-flex-1"
                  size="small"
                  onClick={() => {
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = "image/*";
                    input.onchange = (e) => {
                      const featuredImageUrl = e.target.files[0];
                      setPage((p) => ({ ...p, featuredImageUrl }));
                    };
                    input.click();
                  }}
                >
                  Replace
                </Button>
              </div>
            </div>
          )}
          {!page?.featuredImageUrl && (
            <ImageDropTarget onChange={(file) => setPage((p) => ({ ...p, featuredImageUrl: file }))} />
          )}
          <TextInput
            autoComplete="off"
            placeholder="Ex. Luxury home at night"
            label={
              <>
                Alt Text{" "}
                <Tooltip
                  innerClassName="!tw-text-left tw-max-w-[160px]"
                  trigger={<CircleInfoSolidV6 />}
                  content="Add a description to images on your page to improve SEO and make your website more ADA compliant."
                />
              </>
            }
            disabled={!page?.featuredImageUrl}
            onChange={(e) => {
              const featuredImageAltText = e.target.value || "";
              setPage((p) => ({ ...p, featuredImageAltText }));
            }}
            value={page?.featuredImageAltText || ""}
          />
        </div>
      </CollapsibleWebsiteCard>
      <FeaturedImageHelpModal
        open={featuredImageModalIsOpen}
        onClose={() => setFeaturedImageModalIsOpen(false)}
      />
    </>
  );
};

export default ThumbnailPanel;
